'use strict';
'use es6';

/**
 * @description Check if the client has capabilities on `channels`
 *
 * @param {Realtime.Auth} auth Ably authentication object
 * @param {Array<String>} channels channels to check
 * @returns {Boolean} true when the client has capabilities
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasCapability = exports.hasCapability = function hasCapability(auth, channels) {
  try {
    if (auth.tokenDetails.expires < Date.now()) {
      return false;
    }

    var capability = JSON.parse(auth.tokenDetails.capability);
    return channels.every(function (channel) {
      return !!capability[channel];
    });
  } catch (e) {
    return false;
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/hasCapability.js
// module id = 787
// module chunks = 2 3